import {
  GetDocumentVersionsRequest,
  DocumentVersionResponse,
  GetDocumentVersionMetadataRequest,
  CpsDocumentMetadata
} from '@cs-cms/types';
import { ExecuteEndpoint } from '../base/BaseApiService';

export const buildDocumentVersionEndpointPath = (
  contentType: string,
  documentId: string,
  versionId: string,
  indexId: number,
  displayInBrowser = false
) =>
  `content-types/${contentType}/documents/${documentId}/versions/${versionId}/content?indexId=${indexId}&displayInBrowser=${displayInBrowser}`;

export class VersionsService {
  public async getVersions(dto: GetDocumentVersionsRequest): Promise<DocumentVersionResponse[]> {
    const searchParams = new URLSearchParams();
    searchParams.append('indexId', dto.indexId.toString());
    const queryParams = `?${searchParams.toString()}`;

    return ExecuteEndpoint(`content-types/${dto.ctName}/documents/${dto.documentId}/versions${queryParams}`, 'GET');
  }

  public async getVersionMetadata(dto: GetDocumentVersionMetadataRequest): Promise<{ metadata: CpsDocumentMetadata }> {
    const searchParams = new URLSearchParams();
    searchParams.append('indexId', dto.indexId.toString());
    const queryParams = `?${searchParams.toString()}`;

    return ExecuteEndpoint(
      `content-types/${dto.ctName}/documents/${dto.documentId}/versions/${dto.versionId}${queryParams}`,
      'GET'
    );
  }
}
